// We do not export anything by default since we always want to deep import
// like: import { getGlobalObject } from '@sentry/utils/misc';
